import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { BsStarFill } from "../../../assets/icons/vander";
import { usePatientSurgeryStore } from "../../hooks";
import { MainButton, ErrorMessage, LoadingData } from "../../ui";

export const QuizFinalModal = ({ isOpen, setIsOpen, onSubmit, props }) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const { assessmentQuestionGroups = [] } =
    patientSurgery.data.procedure?.assessmentFinal ?? {};

  const {
    isLoading,
    quizFinalAnswers,
    setQuizFinalAnswers,
    showErrorMessage,
    messageText,
  } = props;

  // States ------------------------------------------------//
  const [groupIndex, setGroupIndex] = useState(0);
  const [hover, setHover] = useState({});
  const [error, setError] = useState(null);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const handleRatingChange = (questionId, value) => {
    setQuizFinalAnswers((prevAnswers) => {
      const updatedAnswers = prevAnswers.filter(
        (answer) => answer.questionId !== questionId
      );
      const newAnswers = [
        ...updatedAnswers,
        { questionId, value: value.toString() },
      ];

      // Validar respuestas en tiempo real
      if (validateResponses(newAnswers)) {
        setError(null);
      }

      return newAnswers;
    });
  };

  const handleHoverChange = (questionId, value) => {
    setHover((prevHover) => ({
      ...prevHover,
      [questionId]: value,
    }));
  };

  const validateResponses = (updatedAnswers = quizFinalAnswers) => {
    const currentGroupQuestions =
      assessmentQuestionGroups[groupIndex]?.questionGroup?.questions || [];
    return currentGroupQuestions.every((question) =>
      updatedAnswers.some((answer) => answer.questionId === question.id)
    );
  };

  const handleSubmit = () => {
    if (!validateResponses(quizFinalAnswers)) {
      return setError(
        "Por favor, responde todas las preguntas antes de enviar."
      );
    }
    onSubmit();
  };
  // Efectos -----------------------------------------------//
  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="lg"
      keyboard={false}
      backdrop="static"
    >
      <Modal.Header>
        <h5 className="modal-title">¡Has completado tu procedimiento!</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="vstack gap-4">
          <p className="mb-0">
            Te invitamos a responder una breve encuesta para mejorar nuestra
            experiencia y agendar tu sesión de finalización.
          </p>

          {assessmentQuestionGroups[groupIndex].questionGroup.questions.map(
            (question, index) => (
              <div key={question.id}>
                <p className="mb-0">
                  <b>{index + 1}. </b>
                  {question.title}
                </p>
                <div className="d-flex gap-2">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <BsStarFill
                      key={index}
                      className={`icon`}
                      style={{
                        width: "32px",
                        height: "32px",
                        cursor: "pointer",
                        color:
                          index + 1 <=
                          (hover[question.id] ||
                            parseInt(
                              quizFinalAnswers.find(
                                (a) => a.questionId === question.id
                              )?.value || "0"
                            ))
                            ? "#FFC107"
                            : "#ADB5BD",
                      }}
                      onClick={() => handleRatingChange(question.id, index + 1)}
                      onMouseEnter={() =>
                        handleHoverChange(question.id, index + 1)
                      }
                      onMouseLeave={() => handleHoverChange(question.id, 0)}
                    />
                  ))}
                </div>
              </div>
            )
          )}

          {/* Mensajes */}
          {isLoading && <LoadingData />}
          {(error || showErrorMessage) && (
            <ErrorMessage>{error || messageText}</ErrorMessage>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <MainButton type="button" onClick={handleSubmit} disabled={isLoading}>
          Enviar
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
